// extracted by mini-css-extract-plugin
module.exports = {"button":"src-components-NotFound-index-module__button--2_UvA"};